
export enum DiscountTarget
{
    WholeBasket = "whole-basket",
    RentalItems = "rental-items",
    SaleItems = "sale-items",
    SpecificItem = "specific-item"
}
